import Parser from 'html-react-parser';

import l from '../../../../lang';
import CardTitle from '../../../common/card-title';
import Card from '../../../common/card';
import CardDescription from '../../../common/card-description';

const PendingKyc2 = () => {
  return (
    <Card>
      <CardTitle>{l('home.pendingKyc2.title')}</CardTitle>
      <CardDescription>{Parser(l('home.pendingKyc2.desc'))}</CardDescription>
    </Card>
  );
};

export default PendingKyc2;
